import { State } from 'src/replicant/State';
import { levelRuleset } from './level.ruleset';

/**
 * Returns the current level of the player.
 * @param state
 * @returns
 */
export function getCurrentLevel(state: State): number {
  return levelRuleset.toDisplay(state.level.current);
}
